// extracted by mini-css-extract-plugin
export var checkIcon = "rendez-vous-part-1-module--check-icon--9b817";
export var rendezVousCheckbox = "rendez-vous-part-1-module--rendez-vous-checkbox--3e075";
export var rendezVousChoiceTypeContainer = "rendez-vous-part-1-module--rendez-vous-choice-type-container--6e53e";
export var rendezVousLoadingSpinner = "rendez-vous-part-1-module--rendez-vous-loading-spinner--0adee";
export var rendezVousLoadingWrapper = "rendez-vous-part-1-module--rendez-vous-loading-wrapper--bb011";
export var rendezVousSubContainer = "rendez-vous-part-1-module--rendez-vous-sub-container--46cc6";
export var rendezVousTitle = "rendez-vous-part-1-module--rendez-vous-title--2f8a3";
export var spanContainer = "rendez-vous-part-1-module--span-container--b5abe";